<script>
    import { fade } from 'svelte/transition';
    import { scale } from 'svelte/transition';
    import UserStore from '../../stores/user';
    import fetchData from '../../api.js';
    import { push , link , replace} from 'svelte-spa-router'
    import { _ } from 'svelte-i18n';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    

</script>
<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Header />
    <div class="page flex justify-center items-center flex-col">

        <div class="text-center">
            <div class="logo w-[300px] my-5">
            {#if shippingo=="1"}
                <img src="{siteUrl}images/0.svg">
            {:else if shippingo=="2"}
                <img src="{siteUrl}images/datalogics.svg">
            {:else if shippingo=="10"}
                <img src="{siteUrl}images/merchandiser.svg">
            {:else}
                <!-- <img src="{siteUrl}images/{shipping_push_supplier}.svg"> -->
            {/if}
            </div>
            <h1 class="text-[25px] font-bold text-center my-4">
                {$_('support.title')}
            </h1>
            <p class="text-[16px]">
                {#if shippingo=="1"}
                {@html $_('support.msg')}
                {:else}
                {@html $_('support.msg2')}
                {/if}
            </p>
        </div>
    </div>

</div>
